module.exports = __webpack_public_path__ + "media/images/weo-replacement-27ab6e5f58eefec13e101cdb6b38c8b0.png";